export const FETCH_KNOWLEDGE_BASES_CATEGORY_LIST =
  'FETCH_KNOWLEDGE_BASES_CATEGORY_LIST'
export const RECEIVE_KNOWLEDGE_BASES_CATEGORY_LIST =
  'RECEIVE_KNOWLEDGE_BASES_CATEGORY_LIST'

export const FETCH_KNOWLEDGE_BASES_HIGHLIGHTS_LIST =
  'FETCH_KNOWLEDGE_BASES_HIGHLIGHTS_LIST'
export const RECEIVE_KNOWLEDGE_BASES_HIGHLIGHTS_LIST =
  'RECEIVE_KNOWLEDGE_BASES_HIGHLIGHTS_LIST'

export const FETCH_KNOWLEDGE_BASES_RECENTS_LIST =
  'FETCH_KNOWLEDGE_BASES_RECENTS_LIST'
export const RECEIVE_KNOWLEDGE_BASES_RECENTS_LIST =
  'RECEIVE_KNOWLEDGE_BASES_RECENTS_LIST'

export const FETCH_SELECTED_ITEM_KNOWLEDGE_BASES =
  'FETCH_SELECTED_ITEM_KNOWLEDGE_BASES'
export const RECEIVE_SELECTED_ITEM_KNOWLEDGE_BASES =
  'RECEIVE_SELECTED_ITEM_KNOWLEDGE_BASES'

export const SET_FILTERS_KNOWLEDGE_BASES = 'SET_FILTERS_KNOWLEDGE_BASES'

export const SET_ITEM_KNOWLEDGE_BASES = 'SET_ITEM_KNOWLEDGE_BASES'
